import { ApiRequestError, type ApiValue } from '../../api/client'

// Parsed shape of the backend's `{ detail: { code, message, expected?, actual? } }`
// error envelope for /admin/flags. `code` stays a plain string (compared against
// the FlagErrorCode literals at the call site) so we never need an `as` cast.
export interface ParsedFlagError {
  code?: string
  message: string
  actual?: number
}

function isRecord(value: ApiValue | null): value is Record<string, ApiValue> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

// Narrow a caught Error into the structured flag-error shape. Non-ApiRequestError
// errors (or ones without a structured detail) fall back to the message text.
export function parseFlagError(err: Error): ParsedFlagError {
  if (err instanceof ApiRequestError) {
    const data = err.errorData
    const detail = isRecord(data) ? data.detail : undefined
    if (isRecord(detail)) {
      const code = typeof detail.code === 'string' ? detail.code : undefined
      const message = typeof detail.message === 'string' ? detail.message : err.message
      const actual = typeof detail.actual === 'number' ? detail.actual : undefined
      return { code, message, actual }
    }
  }
  return { message: err.message }
}
